import modalStyles from './Modal.module.css';

import { ReactNode } from 'react';

export interface ModalParams {
  onClose: () => void; // Callback to close the modal
  title: string; // Title of the modal
  children: ReactNode; // Any TSX content to display in the modal
}

export const Modal = (
  { onClose, title, children }: ModalParams
): React.JSX.Element => {
  return (
    <div className={modalStyles['modal-background']}>
      <div className={modalStyles['modal-window']}>
        <div className={modalStyles['modal-header']}>
          <div className={modalStyles['modal-title']}>{title}</div>
          <button className="drawer-close" onClick={onClose} aria-label="Close modal">
            <span className="close-icon">×</span>
          </button>
        </div>

        <div className="maxxed-element">
          {children}
        </div>

      </div>
    </div>
  );
};
